<template>
  <div class="container">
    <vx-card title="Reportes de balances a terceros">
      <table class="table table-bordered">
        <tr>
          <td>Fecha del balance</td>
          <td class="text-right">{{thirdPartyBalanceReport.balance_date}}</td>
        </tr>
        <tr class="bg-black text-white">
          <td colspan="2">
            <div class="text-center font-bold">
              Mes (cierre del mes anterior)
            </div>
          </td>
        </tr>
        <tr>
          <td>Balance Inversionistas</td>
          <td class="text-right">{{thirdPartyBalanceReport.investor_balance|currency}}</td>
        </tr>
        <tr>
          <td>Balance Solicitante</td>
          <td class="text-right">{{thirdPartyBalanceReport.applicant_balance|currency}}</td>
        </tr>
        <tr class="bg-black text-white">
          <td colspan="2">
            <div class="text-center font-bold">
              Pagos Pendientes por liquidar
            </div>
          </td>
        </tr>
        <tr>
          <td>Retiros a RedGirasol</td>
          <td class="text-right">{{thirdPartyBalanceReport.rg_withdrawal_pending|currency}}</td>
        </tr>
        <tr>
          <td>Retiros a inversionistas</td>
          <td class="text-right">{{thirdPartyBalanceReport.investor_withdrawal_pending|currency}}</td>
        </tr>
        <tr>
          <td>Retiros a instaladores</td>
          <td class="text-right">{{thirdPartyBalanceReport.supplier_withdrawal_pending|currency}}</td>
        </tr>
        <tr>
          <td>Retiros a Solicitantes</td>
          <td class="text-right">{{thirdPartyBalanceReport.applicant_withdrawal_pending|currency}}</td>
        </tr>
        <tr class="bg-black text-white">
          <td colspan="2">
            <div class="text-center font-bold">
              Casos especiales
            </div>
          </td>
        </tr>
        <tr>
          <td>Bonos a Inversionistas</td>
          <td class="text-right">{{thirdPartyBalanceReport.investor_bonus|currency}}</td>
        </tr>
        <tr>
          <td>Bonos a Inversionistas</td>
          <td class="text-right">{{thirdPartyBalanceReport.investor_admin_commission|currency}}</td>
        </tr>
      </table>
    </vx-card>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "ThirdPartyBalanceReport",
  data: () => ({
    thirdPartyBalanceReport: {
      id : "",
      balance_date : "",
      investor_balance : "",
      applicant_balance : "",
      rg_withdrawal_pending : "",
      supplier_withdrawal_pending : "",
      investor_withdrawal_pending : "",
      applicant_withdrawal_pending : "",
      investor_bonus : "",
      investor_admin_commission : ""
    },
    balanceDate: null
  }),
  async mounted() {
    this.balanceDate = moment().subtract(1, 'month').endOf('month').format("Y-M-DD")
    const {data} = await axios.get(`/api/third-party-balance-report?balance_date=${this.balanceDate}`)
    this.thirdPartyBalanceReport = data;
  }
}
</script>

<style scoped>

</style>
